import { render, staticRenderFns } from "./PositionListAddNew.vue?vue&type=template&id=1fc452dc&"
import script from "./PositionListAddNew.vue?vue&type=script&lang=js&"
export * from "./PositionListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PositionListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports